import React, {Component} from 'react';
import {Route} from 'react-router';

import {Header} from 'semantic-ui-react';

import RedditList from './List';
import RelativeSwitch from '../../../containers/RelativeSwitch';

export default class RedditSwitch extends Component {
    render() {
        return <RelativeSwitch name="reddit">
            <Route component={RedditList} exact={true} path="/"/>
            <Route component={RedditList} path="/r/:subreddit"/>
            <Route>
                <Header as='h1'>Page Not Found on Reddit</Header>
            </Route>
        </RelativeSwitch>;
    }
}


// WEBPACK FOOTER //
// ./src/portfolio/api/reddit/Switch.js